<template>
  <div class="pt-[22px] md:pt-[50px]">
    <div class="md:flex justify-between content-end">
      <LazyDiscoverHeroContent
        class="md:w-[50%] content-end"
        :info="info"
        @scroll-to-activities="emit('scroll-to-activities')"
        @update-height="updateHeight"
      />
      <LazyDiscoverHeroImg
        class="max-md:hidden"
        :product-number="productNumber"
        :info="info"
        :max-height="maxHeight"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IDiscoverInfo } from "../../types/general";
import { ref, type PropType } from "vue";

defineProps({
  info: { type: Object as PropType<IDiscoverInfo>, required: true },
  productNumber: { type: Number, required: true },
});
const maxHeight = ref();
const emit = defineEmits(["scroll-to-activities"]);
function updateHeight(val) {
  maxHeight.value = val;
}
</script>
